import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import type { SurgeIntelligenceResponse } from '../types/calculations';

export function useSurgeIntelligence(submarketName: string | undefined) {
  return useQuery<SurgeIntelligenceResponse>({
    queryKey: ['surge-intelligence', submarketName],
    queryFn: async () => {
      const encoded = encodeURIComponent(submarketName!);
      const { data } = await api.get<SurgeIntelligenceResponse>(
        `/rent-growth/surge-intelligence/${encoded}`
      );
      return data;
    },
    enabled: !!submarketName,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
